import { render, staticRenderFns } from "./ActivitiesWithIssuesSummary.vue?vue&type=template&id=5bb4cf3e&"
import script from "./ActivitiesWithIssuesSummary.vue?vue&type=script&lang=js&"
export * from "./ActivitiesWithIssuesSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bb4cf3e')) {
      api.createRecord('5bb4cf3e', component.options)
    } else {
      api.reload('5bb4cf3e', component.options)
    }
    module.hot.accept("./ActivitiesWithIssuesSummary.vue?vue&type=template&id=5bb4cf3e&", function () {
      api.rerender('5bb4cf3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/Reports/ActivitiesWithIssuesSummary.vue"
export default component.exports